import { BasicInput, SelectComponent } from 'Common/Components';
import Modal from 'Common/Components/Modal';
import { useAddRoles } from '../../hooks';
import { useRoleStore } from '../../store';
import { useTranslation } from 'react-i18next';
import { BasicButton } from 'Common/Components/UI/Atoms/Buttons';
import { getDefaultValueForSelect } from 'helpers/functionsHelpers';

export const ModalAddRoles = () => {
  const {
    isOpenModalRole,
    handleCloseModalRole,
    setIsEdit,
    isEdit,
    setRole
  } = useRoleStore();
  const { t } = useTranslation();
  const { formik, optionCompany, valueCompany } = useAddRoles();

  return (
    <Modal
      show={isOpenModalRole}
      onHide={() => {
        handleCloseModalRole();
        setRole(null);
        setIsEdit(false);
        formik.resetForm();
      }}
      id='defaultModal'
      modal-center='true'
      className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-[1050] flex flex-col transition-all duration-300 ease-in-out"
      dialogClassName='w-screen md:w-[30rem] bg-white shadow rounded-md dark:bg-zink-600'
    >
      <Modal.Header
        className='flex items-center justify-between p-4 border-b dark:border-zink-300/20'
        closeButtonClass='transition-all duration-200 ease-linear text-slate-400 hover:text-red-500'
      >
        <Modal.Title className='text-16'>
          {!!isEdit
            ? t('rolesScreen.formAdminRoles.TitleEdit')
            : t('rolesScreen.formAdminRoles.TitleCreate')}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="max-h-[calc(theme('height.screen')_-_180px)] p-4 overflow-y-auto">
        <form
          className='mt-8'
          id='signInForm'
          onSubmit={(event) => {
            event.preventDefault();
            formik.handleSubmit();
          }}
        >
          <BasicInput
            label={t('rolesScreen.formAdminRoles.fieldDescription')}
            placeholder={t('rolesScreen.formAdminRoles.fieldDescription')}
            id='description'
            name='description'
            type='text'
            value={formik.values.description}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isError={
              !!(formik.touched.description && formik.errors.description)
            }
            errorMessage={formik.errors.description || ''}
          ></BasicInput>

          <div className='col-span-6'>
            <SelectComponent
              label={t('rolesScreen.formAdminRoles.fieldCompany')}
              placeholder={t('rolesScreen.FormValidates.CompanyRequired')}
              id='company_id'
              options={optionCompany}
              isMulti={false}
              onChange={(e) => formik.setFieldValue('company_id', e.value)}
              onBlur={formik.handleBlur}
              value={valueCompany}
              defaultValue={getDefaultValueForSelect(
                optionCompany,
                formik.values.company_id.toString()
              )}
            >
            </SelectComponent>
          </div>
          <div className="col-span-12">
            <div className="flex justify-end">
              <BasicButton
                disabled={formik.isSubmitting}
                type="submit"
                onClick={() => { }}>
                <span className="text-white">
                  {!!isEdit
                    ? t('rolesScreen.formAdminRoles.TitleEdit')
                    : t('rolesScreen.formAdminRoles.btnSave')
                  }
                </span>
              </BasicButton>
            </div>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};
